import { render, staticRenderFns } from "./Arrival.vue?vue&type=template&id=7d618d08&scoped=true&"
import script from "./Arrival.vue?vue&type=script&lang=js&"
export * from "./Arrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d618d08",
  null
  
)

export default component.exports